import { useContext } from 'react';

import PlatformContext from '../context/PlatformContext';

const usePlatform = () => {
  const ctx = useContext(PlatformContext);

  if (!ctx) {
    throw new Error('usePlatform must be used within a PlatformProvider');
  }

  return ctx;
};

export default usePlatform;
